module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      arabic: _vm.interfaceLanguage == 'ar'
    },
    attrs: {
      "id": "app"
    }
  }, [_c('app-header'), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [(_vm.showNav) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "vue-tabs stacked"
  }, [_c('div', {
    staticClass: "left-vertical-tabs"
  }, [_c('div', {
    staticClass: "nav-tabs-wrapper stacked"
  }, [_c('ul', {
    staticClass: "nav nav-pills nav-stacked"
  }, [_c('li', {
    staticClass: "tab"
  }, [_c('router-link', {
    attrs: {
      "to": "/moje-konto"
    }
  }, [_vm._v(_vm._s(_vm.$t('MY_ACCOUNT')))])], 1), _vm._v(" "), _c('li', {
    staticClass: "tab"
  }, [_c('router-link', {
    attrs: {
      "to": "/wyniki-badan"
    }
  }, [_vm._v("\n                                        " + _vm._s(_vm.$t('MEDICAL_RESULTS')) + "\n                                        "), (_vm.unreadExaminationsNumber > 0) ? _c('span', {
    staticClass: "unreaded-length"
  }, [_vm._v("\n                                            " + _vm._s(_vm.unreadExaminationsNumber) + "\n                                        ")]) : _vm._e()])], 1), _vm._v(" "), (!_vm.accountTypeIsPro) ? _c('li', {
    staticClass: "tab"
  }, [_c('router-link', {
    attrs: {
      "to": "/moje-dane"
    }
  }, [_vm._v(_vm._s(_vm.$t('MY_MEDICAL_DATA')))])], 1) : _vm._e(), _vm._v(" "), (!_vm.accountTypeIsPro) ? _c('li', {
    staticClass: "tab"
  }, [_c('router-link', {
    attrs: {
      "to": "/moje-zakupy"
    }
  }, [_vm._v(_vm._s(_vm.$t('MY_ORDERS')))])], 1) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "tab"
  }, [_c('router-link', {
    attrs: {
      "to": "/kody-aktywacyjne"
    }
  }, [_vm._v(_vm._s(_vm.$t('ACTIVATION_CODES')))])], 1), _vm._v(" "), _c('li', {
    staticClass: "tab"
  }, [_c('router-link', {
    attrs: {
      "to": "/ustawienia"
    }
  }, [_vm._v(_vm._s(_vm.$t('SETTINGS')))])], 1), _vm._v(" "), (_vm.isBuyForWoman) ? _c('li', {
    staticClass: "tab"
  }, [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": _vm.activateBuyForWomanAccount
    }
  }, [_vm._v("\n                                        " + _vm._s(_vm.$t('ACTIVATE_ACCOUNT')) + "\n                                    ")])]) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "tab tab--last"
  }, [_c('a', {
    staticClass: "tab--last--href",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": _vm.openDictionary
    }
  }, [_c('p', {
    staticStyle: {
      "text-align": "center",
      "width": "100%"
    }
  }, [_vm._v("\n                                            " + _vm._s(_vm.$t('DICTONARY_OF_CONCEPTS')) + "\n                                        ")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-content right-text-tabs"
  }, [_c('transition', {
    attrs: {
      "name": "slide",
      "mode": "out-in"
    }
  }, [_c('router-view', {
    attrs: {
      "name": "componentsview"
    }
  })], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "box-footer"
  }, [_c('router-view', {
    attrs: {
      "name": "map"
    }
  })], 1)])]) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1), _vm._v(" "), (!_vm.accountTypeIsPro) ? _c('router-view', {
    staticClass: "mt-5",
    attrs: {
      "name": "info"
    }
  }) : _vm._e(), _vm._v(" "), _c('app-footer'), _vm._v(" "), (_vm.showLoadingSpinner) ? _c('div', {
    staticClass: "loading"
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7ee3dcf0","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 1223
// module chunks = 0